(() => {
  const headerGroup = document.querySelector('.shopify-section-group-header-group') || document.querySelector('.header-group');
  const menu = document.getElementById('MobileMenu');
  const searchModal = document.getElementById('SearchModal');
  const searchToggle = document.querySelector('[data-open-search]');
  const searchInput = document.getElementById('SearchModalInput');
  const menuToggle = document.querySelector('[data-open-menu]');
  const resultsBox = document.querySelector('[data-predictive-results]');

  if (searchModal && searchModal.parentElement !== document.body) {
    document.body.appendChild(searchModal);
  }

  if (menu && menu.parentElement !== document.body) {
    document.body.appendChild(menu);
  }

  const setOpen = (el, isOpen, bodyClass) => {
    if (!el) return;
    el.classList.toggle('is-open', isOpen);
    el.hidden = !isOpen;
    document.body.classList.toggle(bodyClass, isOpen);
  };

  const closeMenu = (restoreFocus = false) => {
    setOpen(menu, false, 'menu-open');
    menuToggle?.setAttribute('aria-expanded', 'false');
    if (restoreFocus) menuToggle?.focus();
  };

  const closeSearch = (restoreFocus = false) => {
    setOpen(searchModal, false, 'search-open');
    searchToggle?.setAttribute('aria-expanded', 'false');
    if (resultsBox) resultsBox.replaceChildren();
    if (restoreFocus) searchToggle?.focus();
  };

  const openMenu = () => {
    closeSearch();
    setOpen(menu, true, 'menu-open');
    menuToggle?.setAttribute('aria-expanded', 'true');
    window.requestAnimationFrame(() => {
      const firstLink = menu?.querySelector('.drawer__nav-link, [data-close-menu].icon-btn');
      firstLink?.focus();
    });
  };

  const openSearch = () => {
    closeMenu();
    setOpen(searchModal, true, 'search-open');
    searchToggle?.setAttribute('aria-expanded', 'true');
    window.requestAnimationFrame(() => searchInput?.focus());
  };

  const getFocusable = (root) =>
    [...root.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])')]
      .filter((el) => !el.hasAttribute('disabled') && el.getAttribute('aria-hidden') !== 'true');

  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-open-menu]')) {
      openMenu();
      return;
    }
    if (event.target.closest('[data-close-menu]')) {
      const alsoOpenSearch = event.target.closest('[data-open-search]');
      closeMenu(false);
      if (alsoOpenSearch) {
        openSearch();
        return;
      }
      menuToggle?.focus();
      return;
    }
    if (event.target.closest('[data-open-search]')) {
      openSearch();
      return;
    }
    if (event.target.closest('[data-close-search]')) {
      closeSearch(true);
    }
  });

  searchModal?.querySelector('.search-modal__dialog')?.addEventListener('click', (event) => {
    event.stopPropagation();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    if (document.body.classList.contains('search-open')) {
      closeSearch(true);
      return;
    }
    if (document.body.classList.contains('menu-open')) {
      closeMenu(true);
    }
  });

  const trapFocus = (root, event) => {
    if (event.key !== 'Tab' || !root || root.hidden) return;
    const focusable = getFocusable(root);
    if (focusable.length < 2) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  };

  searchModal?.addEventListener('keydown', (event) => {
    const dialog = searchModal.querySelector('.search-modal__dialog') || searchModal;
    trapFocus(dialog, event);
  });

  menu?.addEventListener('keydown', (event) => {
    const panel = menu.querySelector('.drawer__panel') || menu;
    trapFocus(panel, event);
  });

  let lastScrollY = window.scrollY;
  let scrollTicking = false;

  const updateHeader = () => {
    scrollTicking = false;
    if (!headerGroup) return;

    const y = Math.max(0, window.scrollY);
    headerGroup.classList.toggle('is-scrolled', y > 8);

    const overlayOpen = document.body.classList.contains('menu-open') || document.body.classList.contains('search-open');
    if (overlayOpen || y < 64) {
      headerGroup.classList.remove('is-header-hidden');
      lastScrollY = y;
      return;
    }

    if (y > lastScrollY + 6) {
      headerGroup.classList.add('is-header-hidden');
    } else if (y < lastScrollY - 6) {
      headerGroup.classList.remove('is-header-hidden');
    }
    lastScrollY = y;
  };

  updateHeader();
  window.addEventListener('scroll', () => {
    if (scrollTicking) return;
    scrollTicking = true;
    window.requestAnimationFrame(updateHeader);
  }, { passive: true });

  const predictiveInput = document.querySelector('[data-predictive-search]');
  let predictiveTimer;
  let predictiveAbort;

  const shopifyRoot = () => (window.Shopify?.routes?.root || '/').replace(/\/?$/, '/');

  const productImageUrl = (product) => {
    const image = product.featured_image || product.image;
    if (!image) return '';
    if (typeof image === 'string') return image;
    return image.url || image.src || '';
  };

  const appendResultLink = (list, href, title, imageUrl) => {
    const item = document.createElement('li');
    const link = document.createElement('a');
    link.href = href;
    if (imageUrl) {
      const thumb = document.createElement('span');
      thumb.className = 'search-modal__thumb';
      const img = document.createElement('img');
      img.src = imageUrl;
      img.alt = '';
      img.width = 56;
      img.height = 56;
      thumb.append(img);
      link.append(thumb);
    }
    const label = document.createElement('span');
    label.textContent = title;
    link.append(label);
    item.append(link);
    list.append(item);
  };

  const renderStatus = (message) => {
    if (!resultsBox) return;
    resultsBox.replaceChildren();
    if (!message) return;
    const status = document.createElement('p');
    status.className = 'form-status';
    status.textContent = message;
    resultsBox.append(status);
  };

  const renderPredictive = (data, query) => {
    if (!resultsBox) return;
    const products = data?.resources?.results?.products || [];
    const pages = data?.resources?.results?.pages || [];
    resultsBox.replaceChildren();

    if (!products.length && !pages.length) {
      renderStatus(resultsBox.dataset.empty || '');
      return;
    }

    const list = document.createElement('ul');
    list.className = 'search-modal__list';
    list.setAttribute('role', 'list');
    products.forEach((product) => {
      appendResultLink(list, product.url, product.title, productImageUrl(product));
    });
    pages.forEach((page) => {
      appendResultLink(list, page.url, page.title);
    });

    if (query && resultsBox.dataset.viewAll) {
      const searchForm = searchModal?.querySelector('form');
      const viewAllUrl = new URL(searchForm?.action || '/search', window.location.origin);
      viewAllUrl.searchParams.set('q', query);
      viewAllUrl.searchParams.set('type', 'product,page');
      appendResultLink(list, `${viewAllUrl.pathname}${viewAllUrl.search}`, resultsBox.dataset.viewAll);
    }

    resultsBox.append(list);
  };

  if (predictiveInput && resultsBox) {
    predictiveInput.addEventListener('input', () => {
      const query = predictiveInput.value.trim();
      window.clearTimeout(predictiveTimer);
      predictiveAbort?.abort();
      if (query.length < 2) {
        resultsBox.replaceChildren();
        return;
      }
      renderStatus(resultsBox.dataset.loading || '');
      predictiveTimer = window.setTimeout(() => {
        const params = new URLSearchParams({
          q: query,
          'resources[type]': 'product,page',
          'resources[limit]': '6',
        });
        const url = `${shopifyRoot()}search/suggest.json?${params.toString()}`;
        predictiveAbort = new AbortController();
        fetch(url, { signal: predictiveAbort.signal })
          .then((response) => {
            if (!response.ok) throw new Error('Suggest request failed');
            return response.json();
          })
          .then((data) => renderPredictive(data, query))
          .catch((error) => {
            if (error.name === 'AbortError') return;
            resultsBox.replaceChildren();
          });
      }, 180);
    });
  }

  document.querySelectorAll('[data-gallery-thumb]').forEach((thumb) => {
    thumb.addEventListener('click', () => {
      const main = document.querySelector('.js-gallery-main');
      if (!main) return;
      main.src = thumb.dataset.src;
      document.querySelectorAll('[data-gallery-thumb]').forEach((item) => item.classList.remove('is-active'));
      thumb.classList.add('is-active');
    });
  });

  const loadMap = (placeholder) => {
    if (!placeholder || placeholder.dataset.loaded === 'true') return;
    const src = placeholder.dataset.src;
    if (!src) return;
    placeholder.dataset.loaded = 'true';
    const title = placeholder.querySelector('p')?.textContent || 'Map';
    const iframe = document.createElement('iframe');
    iframe.src = src;
    iframe.title = title;
    iframe.loading = 'lazy';
    iframe.referrerPolicy = 'no-referrer-when-downgrade';
    iframe.setAttribute('allowfullscreen', '');
    placeholder.replaceWith(iframe);
  };
  window.HazzaaLoadMap = loadMap;

  document.querySelectorAll('.js-map-lazy').forEach((placeholder) => {
    placeholder.querySelector('[data-load-map]')?.addEventListener('click', () => loadMap(placeholder));
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries, mapObserver) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            loadMap(entry.target);
            mapObserver.unobserve(entry.target);
          }
        });
      }, { rootMargin: '200px' });
      observer.observe(placeholder);
    }
  });

  document.querySelectorAll('[data-related-products]').forEach((section) => {
    const url = section.dataset.url;
    if (!url) return;
    fetch(url)
      .then((response) => response.text())
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const incoming = doc.querySelector('[data-related-products]');
        if (incoming) {
          section.replaceWith(incoming);
        } else {
          section.remove();
        }
      })
      .catch(() => {});
  });
})();
